import ArtistSearchBaseController from "./artist_search_base"

export default class extends ArtistSearchBaseController {
  static values = {
    ...ArtistSearchBaseController.values,
    roleKey: String,
    roleName: String
  }

  // Implementation of abstract methods from base class
  getCallingControllerType() {
    return `track_role_${this.roleKeyValue}`
  }

  getHiddenInputName() {
    return `track[contributor_roles][${this.roleKeyValue}][artist_ids][]`
  }

  getHiddenInputId(artistId) {
    return `track_contributor_${this.roleKeyValue}_artist_${artistId}`
  }

  getHiddenInputsContainer() {
    // Find the hiddenFields container within the same track-contributor-roles controller scope
    const contributorRolesController = this.element.closest('[data-controller*="track-contributor-roles"]')
    if (contributorRolesController) {
      const hiddenContainer = contributorRolesController.querySelector('[data-track-contributor-roles-target="hiddenFields"]')
      if (hiddenContainer) {
        return hiddenContainer
      }
    }
    // Fallback to local hiddenInputs target
    return this.hiddenInputsTarget
  }

  // Override wireUpExistingArtists to handle server-rendered content
  initializeExistingArtists() {
    // Track already selected artists from server-rendered content
    const existingArtistTags = this.selectedArtistsTarget.querySelectorAll('[data-artist-id]')
    existingArtistTags.forEach(tag => {
      const artistId = parseInt(tag.dataset.artistId)
      if (artistId) {
        this.selectedArtistIds.add(artistId)
      }
    })

    // Call parent method to wire up existing artists
    super.initializeExistingArtists()

    // Additional wiring for role-specific functionality
    this.wireUpExistingArtists()
  }

  wireUpExistingArtists() {
    // Wire up edit buttons
    const editButtons = this.selectedArtistsTarget.querySelectorAll('button[data-action="click"]')
    editButtons.forEach(button => {
      button.addEventListener('click', () => {
        const artistId = button.dataset.artistId
        const artistName = button.dataset.artistName
        this.editArtist({ id: artistId, name: artistName }, artistId, artistName)
      })
    })

    // Wire up remove buttons
    const removeButtons = this.selectedArtistsTarget.querySelectorAll('button[data-artist-id]:not([data-action])')
    removeButtons.forEach(button => {
      const artistId = parseInt(button.dataset.artistId)
      const artistTag = button.closest('.bg-indigo-100')
      const hiddenInput = document.getElementById(`track_contributor_${this.roleKeyValue}_artist_${artistId}`)

      button.addEventListener('click', () => {
        this.removeSelectedArtist(artistId, artistTag, hiddenInput)
      })
    })
  }
}
